exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-written-words-for-fit-nerds-tsx": () => import("./../../../src/pages/written-words-for-fit-nerds.tsx" /* webpackChunkName: "component---src-pages-written-words-for-fit-nerds-tsx" */),
  "component---src-templates-portfolio-post-template-js": () => import("./../../../src/templates/portfolioPostTemplate.js" /* webpackChunkName: "component---src-templates-portfolio-post-template-js" */)
}

